import { useState, useRef, useEffect } from "react"
const LazyWrapper = ({ children, ...props }) => {
    const [isVisible, setIsVisible] = useState(props.skipLazy)
    const ref = useRef(null)

    useEffect(() => {
        if (props.skipLazy) {
            return
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true)
                    observer.disconnect()
                }
            },
            { threshold: 0.1 }
        )

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            if (ref.current) {
                observer.disconnect()
            }
        }
    }, [])

    return (
        <div ref={ref} className={props.className} onClick={props.onClick}>
            {isVisible ? (
                // Support for both render function and direct React node
                typeof children === "function" ? (
                    children(props)
                ) : (
                    children
                )
            ) : (
                <div className="x-inset-light" style={{ opacity: 0.3 }}>
                    Loading...
                </div>
            )}
        </div>
    )
}

export default LazyWrapper
